import type { UserFlow } from "../services/api";

export const USER_FLOW_PARAM = "user_flow";

export function serializeUserFlow(userFlow: UserFlow): string {
  return btoa(JSON.stringify(userFlow));
}

export function deserializeUserFlow(param: string | null): UserFlow | undefined {
  if (!param) return undefined;
  try {
    return JSON.parse(atob(param));
  } catch (e) {
    console.error("Failed to deserialize user flow", e);
    return undefined;
  }
}
